export default __webpack_public_path__ + "static/github-issues-647cd5b4974235e82f57c938e20201cd.png";